import { Action } from 'redux';
import { Template, TemplateType } from '@dev/ee-api/ee-api-models';

import { TemplateListParams } from '../../services/ApiCategories/templates';

export enum TemplatesActionTypes {
    LOADING_START = '@@templateList/LOADING_START',
    LOADING_SUCCESS = '@@templateList/LOADING_SUCCESS',
    LOADING_ERROR = '@@templateList/LOADING_ERROR',
    DELETE_START = '@@templateList/DELETE_START',
    DELETE_SUCCESS = '@@templateList/DELETE_SUCCESS',
    DELETE_ERROR = '@@templateList/DELETE_ERROR',
    DELETE_ARRAY_START = '@@templateList/DELETE_ARRAY_START',
    DELETE_ARRAY_SUCCESS = '@@templateList/DELETE_ARRAY_SUCCESS',
    DELETE_ARRAY_ERROR = '@@templateList/DELETE_ARRAY_ERROR',
    PREVIEW_START = '@@templateList/PREVIEW_START',
    PREVIEW_SUCCESS = '@@templateList/PREVIEW_SUCCESS',
    PREVIEW_ERROR = '@@templateList/PREVIEW_ERROR',
    UPDATE_START = '@@templateList/UPDATE_START',
    UPDATE_SUCCESS = '@@templateList/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@templateList/UPDATE_ERROR',
    SAVE_TEMPLATE_START = '@@templateList/SAVE_TEMPLATE_START',
    SAVE_TEMPLATE_SUCCESS = '@@templateList/SAVE_TEMPLATE_SUCCESS',
    SAVE_TEMPLATE_ERROR = '@@templateList/SAVE_TEMPLATE_ERROR',
    SHARE_TEMPLATE_START = '@@templateList/SHARE_TEMPLATE_START',
    SHARE_TEMPLATE_SUCCESS = '@@templateList/SHARE_TEMPLATE_SUCCESS',
    SHARE_TEMPLATE_ERROR = '@@templateList/SHARE_TEMPLATE_ERROR',
    CREATE_SHARED_TEMPLATE_START = '@@templateList/CREATE_SHARED_TEMPLATE_START',
    CREATE_SHARED_TEMPLATE_SUCCESS = '@@templateList/CREATE_SHARED_TEMPLATE_SUCCESS',
    CREATE_SHARED_TEMPLATE_ERROR = '@@templateList/CREATE_SHARED_TEMPLATE_ERROR',
    CHANGE_PAGE = '@@templateList/CHANGE_PAGE',
    SET_TEMPLATE_LIST_NAME = '@@templateList/CHANGE_PAGE',
    CLEAR_TEMPLATES = '@@templateList/CLEAR_TEMPLATES'
}

export interface StdLoadListInterface extends TemplateListParams, TemplateListState {}

export interface LoadListStartAction extends Action {
    type: TemplatesActionTypes.LOADING_START;
    payload: StdLoadListInterface;
}

export interface LoadListSuccessAction extends Action {
    type: TemplatesActionTypes.LOADING_SUCCESS;
    payload: StdLoadListInterface;
}

export interface LoadListErrorAction extends Action {
    type: TemplatesActionTypes.LOADING_ERROR;
    payload: StdLoadListInterface;
}

interface TemplateListState {
    loadingTemplates?: boolean;
    isInfinityScroll?: boolean;
    hasMore?: boolean;
    templatesList?: Template[];
    limit?: number;
    page?: number;
    count?: number;
    tags?: Array<string>;
    templateTypes?: TemplateType[];
    UpdatingTemplate?: boolean;
    DeletingTemplate?: boolean;
    PreviewLoading?: boolean;
    templateSaving?: boolean;
    name?: string;
    template?: Template;
    templateObject?: Template;
    templatesToDelete?: Array<string>;
    pageToLoad?: any;
    ispublic?: boolean;
    removeScreenshot?: boolean;
    prevTemplateName?: string;
    changes?: Template;
    shareIdentifier?: string;
}

export type DeleteTemplateInterface = StdLoadListInterface;

export interface templateDeleteStartAction extends Action {
    type: TemplatesActionTypes.DELETE_START;
    payload: DeleteTemplateInterface;
}

export interface templateDeleteSuccessAction extends Action {
    type: TemplatesActionTypes.DELETE_SUCCESS;
    payload: DeleteTemplateInterface;
}

export interface templateDeleteErrorAction extends Action {
    type: TemplatesActionTypes.DELETE_ERROR;
    payload: DeleteTemplateInterface;
}
export interface templateArrayDeleteStartAction extends Action {
    type: TemplatesActionTypes.DELETE_ARRAY_START;
    payload: DeleteTemplateInterface;
}
export interface templateArrayDeleteSuccessAction extends Action {
    type: TemplatesActionTypes.DELETE_ARRAY_SUCCESS;
    payload: DeleteTemplateInterface;
}
export interface templateArrayDeleteErrorAction extends Action {
    type: TemplatesActionTypes.DELETE_ARRAY_ERROR;
    payload: DeleteTemplateInterface;
}
export type PreviewTemplateInterface = TemplateListState;

export interface templatePreviewStartAction extends Action {
    type: TemplatesActionTypes.PREVIEW_START;
    payload: PreviewTemplateInterface;
}

export interface templatePreviewSuccessAction extends Action {
    type: TemplatesActionTypes.PREVIEW_SUCCESS;
    payload: PreviewTemplateInterface;
}

export interface templatePreviewErrorAction extends Action {
    type: TemplatesActionTypes.PREVIEW_ERROR;
    payload: PreviewTemplateInterface;
}
export type UpdateTemplateInterface = TemplateListState;

export interface templateUpdateStartAction extends Action {
    type: TemplatesActionTypes.UPDATE_START;
    payload: UpdateTemplateInterface;
}

export interface templateUpdateSuccessAction extends Action {
    type: TemplatesActionTypes.UPDATE_SUCCESS;
    payload: UpdateTemplateInterface;
}

export interface templateUpdateErrorAction extends Action {
    type: TemplatesActionTypes.UPDATE_ERROR;
    payload: UpdateTemplateInterface;
}

export type SaveTemplateInterface = TemplateListState;

export interface SaveTemplateStartAction extends Action {
    type: TemplatesActionTypes.SAVE_TEMPLATE_START;
    payload: SaveTemplateInterface;
}

export interface SaveTemplateSuccessAction extends Action {
    type: TemplatesActionTypes.SAVE_TEMPLATE_SUCCESS;
    payload: SaveTemplateInterface;
}

export interface SaveTemplateErrorAction extends Action {
    type: TemplatesActionTypes.SAVE_TEMPLATE_ERROR;
    payload: SaveTemplateInterface;
}

export interface ShareTemplateStartAction extends Action {
    type: TemplatesActionTypes.SHARE_TEMPLATE_START;
    payload: {
        name: string;
    };
}

export interface ShareTemplateSuccessAction extends Action {
    type: TemplatesActionTypes.SHARE_TEMPLATE_SUCCESS;
    payload: {
        shareIdentifier: string;
    };
}

export interface ShareTemplateErrorAction extends Action {
    type: TemplatesActionTypes.SHARE_TEMPLATE_ERROR;
}

export interface CreateSharedTemplateInterface
    extends TemplateListParams,
        Pick<TemplateListState, 'loadingTemplates' | 'page' | 'template'> {}

export interface CreateSharedTemplateStartAction extends Action {
    type: TemplatesActionTypes.CREATE_SHARED_TEMPLATE_START;
    payload: {
        shareIdentifier: string;
    };
}
export interface CreateSharedTemplateSuccessAction extends Action {
    type: TemplatesActionTypes.CREATE_SHARED_TEMPLATE_SUCCESS;
    payload: CreateSharedTemplateInterface;
}
export interface CreateSharedTemplateErrorAction extends Action {
    type: TemplatesActionTypes.CREATE_SHARED_TEMPLATE_ERROR;
}

export interface SetTemplateListNameAction extends Action {
    type: TemplatesActionTypes.SET_TEMPLATE_LIST_NAME;
    payload: {
        name: string;
    };
}

export { TemplateListState };
